<template>
  <div id="app">
    <el-container class="top">
      <div class="container">
        <el-header>
          <el-row>
            <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8">
              <div class="grid-content bg-purple logo"></div>
            </el-col>
            <el-col :xs="24" :sm="24" :md="16" :lg="16" :xl="16">
              <div class="grid-content bg-purple-light">
                <div class="textright language"  v-if="islang">
                  <a :href="Url+'en'">
                    <img src="../assets/images/lang.png" width="17px">
                    English
                  </a>
                </div>
                <div class="rightfloat search hidden-sm-and-down">
                  <!-- 搜索区域 -->
                  <Search />
                </div>
                <div class="clearfix"></div>
                <div class="index-nav nav_menu">
                  <div class="index-nav-frame clearfix">
                    <!-- logo -->
                    <div class="nav-small" tabindex="-1" @click="onMnav" v-if="!isgzh">
                      <div class="nav-small-focus" tabindex="-1" v-if="isgzhl!=2"></div>
                      <img src="../assets/images/icon.png" v-if="isgzhl!=2"/>
                    </div>
                    <div v-for="(item,index) in NavList" :key="index" class="index-nav-frame-line pclist">
                       <span @click="$router.push(item.path)" >{{item.name}}</span>
					  <span v-if="item.children" class="rotator"> <img src="../assets/images/down.png"> </span>
					  <div v-if="item.children" class="index-nav-frame-line-center" :class="'list'+index">
					    <div class="index-nav-frame-line-li" :class="'list'+index+''+i"  v-for="(val,i) in item.children" :key="i" >
						 <span @click="$router.push(val.path)" >{{val.name}}</span>
					    </div>
					  </div>
                      <div class="index-nav-frame-line-focus"></div>
                    </div>
					<div v-if="ismnav"  ref="treeWrap">
						<div v-for="(items,indexs) in MNavList" :key="10 + indexs" class="index-nav-frame-line mobList index-nav-frame-linem" @click="topath(items.path)">
                       <span>{{items.name}}</span>
                    </div>
					</div>
                  </div>
                </div>
              </div>
            </el-col>
          </el-row>
        </el-header>
      </div>
    </el-container>
  </div>
</template>

<script>
import Search from "./Home/Search";
export default {
  name: "CommonHearde",
  components: {
    Search
  },
  data() {
    return {
	  isycb: false,
    ismnav:false,
    isgzhl:0,
    islang:true,
      NavList: [
        { name: "主页", path: "/" },
        { name: "最新一期", path: "/OAList?IssueId=-1" },
        { name: "预出版", path: "/PreprintList" },
        {
          name: "过刊目录",
          path: "/dlistnum",
          children: [
            {
              name: "过刊目录",
              path: "/dlistnum"
            },
            {
              name: "高级检索",
              path: "/AdvancedSearch"
            },
            {
              name: "下载排行",
              path: "/DownloadlistViewlist?Key=ReadRank"
            },
            {
              name: "浏览排行",
              path: "/DownloadlistViewlist?Key=ViewRank"
            }
          ]
        },
        { name: "期刊动态", path: "/NewsList" },
        {
          name: "投稿须知",
          path: "/FixedBody?ItemId=30"
        },
        {
          name: "作者园地",
          path: "/Authorgarden"
        },
        {
          name: "期刊简介",
          path: "/FixedBody?ItemId=10",
          children: [
            {
              name: "期刊简介",
              path: "/FixedBody?ItemId=10"
            },
            {
              name: "编委会",
              path: "/FixedBody?ItemId=1500"
            },
            {
              name: "收录情况",
              path: "/FixedBody?ItemId=3500"
            }
          ]
        },
        {
          name: "联系我们",
          path: "/FixedBody?ItemId=50"
        }
	  ],
	  MNavList: [
        { name: "主页", path: "/" },
        { name: "最新一期", path: "/OAList?IssueId=-1" },
        { name: "预出版", path: "/PreprintList" },
        {
          name: "过刊目录",
          path: "/dlistnum",
		},
        {
              name: "过刊目录",
              path: "/dlistnum"
            },
            {
              name: "下载排名",
              path: "/DownloadlistViewlist?Key=ReadRank"
            },
            {
              name: "浏览排名",
              path: "/DownloadlistViewlist?Key=ViewRank"
            },
        
        { name: "期刊动态", path: "/NewsList" },
        {
          name: "投稿须知",
          path: "/FixedBody?ItemId=30"
        },
        {
          name: "作者园地",
          path: "/Authorgarden"
        },
        {
          name: "期刊简介",
          path: "/FixedBody?ItemId=10",
		},
            {
              name: "期刊简介",
              path: "/FixedBody?ItemId=10"
            },
            {
              name: "编委会",
              path: "/FixedBody?ItemId=1500"
            },
            {
              name: "收录情况",
              path: "/FixedBody?ItemId=3500"
            },
          
        {
          name: "联系我们",
          path: "/FixedBody?ItemId=50"
        }
      ]
    };
  },
   props:["isgzh"],
  created() {
    if (sessionStorage.getItem("SetItem")) {
      let SetItem = JSON.parse(sessionStorage.getItem("SetItem"));
      SetItem.map(item => {
        if (item.SetItemID == 4530) {
          item.Item_Value == "是" ? (this.isycb = true) : (this.isycb = false);
        }
        if(item.SetItemID == 2900){
          item.Item_Value == "是" ? (this.islang = true) : (this.islang = false);
        }
      });
    }
  },
  mounted(){
     let _this = this;
     if(this.$route.query){
       this.isgzhl=this.$route.query.isgzh
     }
    document.addEventListener('mouseup',(e) =>{
        let tree = this.$refs.treeWrap
        if (tree) {
          if (!tree.contains(e.target)) {
            this.ismnav =false
          }
        }
      })      
  },
  methods:{
	  onMnav(){
		  if(this.ismnav){
			  this.ismnav=false
		  }else{
			  this.ismnav=true
		  }
	  },
	  topath(url){
		  this.$router.push(url)
		  this.ismnav=false
	  }
  }
};
</script>
<style scoped>
.index-nav-frame-linem a{
	width: 100%;
	display: inline-block;

}
@media (max-width:768px){
.language{ position: absolute; top: 5px; right: 10px;}
.quick{ margin-top:-40px !important}
}

</style>
